import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
export const waybillNumber = {
  number: null
}
@Component({
  selector: 'app-universal-search',
  templateUrl: './universal-search.component.html',
  styleUrls: ['./universal-search.component.scss']
})
export class UniversalSearchComponent implements OnInit {
  public waybillNumber;
  public error;
  @Output() messageEvent = new EventEmitter<string>();
  constructor(private router:Router) { }

  ngOnInit() {
    waybillNumber.number != null ? this.waybillNumber = waybillNumber.number: "";
  }
  onSubmit()
  {
    this.messageEvent.emit("tab3");
    this.error = false;
    waybillNumber.number = this.waybillNumber;
    firebase.database().ref("shipments").child(this.waybillNumber).once("value").then((data)=>{
      data.val() != null ? this.gotoViewShipmentDetails() : this.error = true;
    });
  }
  gotoViewShipmentDetails()
  {
    this.router.navigate(['/view-shipment-details'], { queryParams: { key: this.waybillNumber, from: 'shipment' } });
  }
  clear()
  {
    this.waybillNumber = null;
    waybillNumber.number = null;
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/universal-search/universal-search.component.ts